import React from 'react';
import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import { useAppSelector } from '@spartalabs/pdc-core';

export const Progress = () => {
  const { currentStep } = useAppSelector(state => state.scheduleSlicer);

  return (
    <Flex
      width="100%"
      alignItems="center"
      justify="center"
      mt="35px"
      overflowX="auto"
    >
      <>
        <Flex align="center" justify="center">
          <Box
            bg={currentStep <= 3 ? 'brazil.km' : 'gray.100'}
            mr="8px"
            w={10}
            h={10}
            rounded="full"
            textAlign="center"
          >
            <Text mt="8px" fontSize="16px" fontWeight="light">
              1
            </Text>
          </Box>
          <Text color="text.100">Veículo</Text>
        </Flex>

        <Divider
          borderWidth="1px"
          borderColor={currentStep > 1 ? 'black' : 'gray.100'}
          orientation="horizontal"
          maxW="309px"
          mx="8px"
          variant="dashed"
          _last={{ display: 'none' }}
        />

        <Flex align="center" justify="center">
          <Box
            bg={currentStep > 1 ? 'brazil.km' : 'gray.100'}
            mr="8px"
            w={10}
            h={10}
            rounded="full"
            textAlign="center"
          >
            <Text mt="8px" fontSize="16px" fontWeight="light">
              2
            </Text>
          </Box>
          <Text color="text.100">Serviços</Text>
        </Flex>

        <Divider
          borderWidth="1px"
          borderColor={currentStep > 2 ? 'black' : 'gray.100'}
          orientation="horizontal"
          maxW="309px"
          mx="8px"
          variant="dashed"
        />

        <Flex align="center" justify="center">
          <Box
            bg={currentStep > 2 ? 'brazil.km' : 'gray.100'}
            mr="8px"
            w={10}
            h={10}
            rounded="full"
            textAlign="center"
          >
            <Text mt="8px" fontSize="16px" fontWeight="light">
              3
            </Text>
          </Box>
          <Text color="text.100">Agenda</Text>
        </Flex>
      </>
    </Flex>
  );
};
